import { render, staticRenderFns } from "./btn-content-options.component.vue?vue&type=template&id=488d2f6f"
import script from "./btn-content-options.component.vue?vue&type=script&lang=ts"
export * from "./btn-content-options.component.vue?vue&type=script&lang=ts"
import style0 from "./btn-content-options.component.vue?vue&type=style&index=0&id=488d2f6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports